import React from "react";
import withStyles from '@mui/styles/withStyles';
import { useHistory } from "react-router-dom";
import LectionPreviewCard from "./lection-preview-card";
import getSectionIconFromType from "../../utils/getSectionIconFromType";



const styles = theme => ({});

const Lection = ({ classes, index, lection }) => {
  let history = useHistory();

  const iconImage = getSectionIconFromType(lection.sectionType)

  return (
    <React.Fragment>
      <LectionPreviewCard
        index={index}
        title={lection.name}
        clickHandler={e => {
          e.preventDefault();
          history.push(`/lections/${lection.id}`);
        }}
        iconUrl={iconImage.enabled}
        disabledIconUrl={iconImage.disabled}
        startDate={lection.startDate}
        startDateDistance={lection.startDateDistance}
        locked={lection.locked}
        finished={lection.finished}
        started={lection.started}
        readableDuration={lection.readableDuration}
        credits={lection.credits}
      />
    </React.Fragment>
  );
};

export default withStyles(styles)(Lection);
